export const BLOCKED_LEAGUES = [
    'west indies championship',
    't20 houston open',
    'houston open',
    't20 st lucia',
    'st lucia premier league',
    'st lucia',
    'leeward islands',
    'tt red force',
    'windies',
    'caribbean championship',
    't20 brisbane champions',
    'brisbane champions',
    'u19 t20 australia',
    'u19 t20',
    'australia tri-series',
    'tri-series, women',
    'one-day cup, women',
    'one-day cup women',
    'first class series sri lanka a vs new zealand a',
    'sri lanka a vs new zealand a',
    't20 ecn rodriguez trophy',
    'ecn rodriguez trophy',
    'rodriguez trophy',
    'list-a inter state challenge cup',
    'list-a inter state premier cup',
    'super 20 series women',
    'super 20 series, women',
    'women super 20 series',
    'list-a topklasse',
    'topklasse',
    'dutch list-a pro series',
    'dutch list-a',
    'seafarers v royals',
    'east african safari challenge',
    'livet20 east african',
    'east african safari',
    'inter state premier cup',
    'inter state challenge cup',
    't20 rawalpindi premier league',
    't20 japan premier league',
    't20 series malaysia vs indonesia',
    'japan premier league',
    'malaysia vs indonesia',
    'icc cricket world cup league two',
    'trinidad t20 festival',
    't20 world cup east asia',
    'east asia-pacific qualifier',
    'east asia pacific qualifier',
    'regional final t20',
    't20 regional final',
    't20 series malta vs gibraltar',
    'malta vs gibraltar',
    'malta gibraltar',
    'world cup league two',
    'cricket world cup league two',
    'rawalpindi premier league',
    't20 challenge trophy, women',
    'metro t10 cup',
    'one-day cup, league 2, women',
    // Matching is a plain substring test (see isLeagueBlocked), so each term below is the
    // narrowest string that hits its target. 'premier league' is deliberately NOT used: it
    // would also hide the Indian/Bangladesh/Caribbean/Lanka Premier Leagues.
    'major league cricket',
    'inter provincial',
    'pondicherry',
    // Hides 'U19 Test Series Sri Lanka vs India 2026' and any other age-group fixture.
    // The feed writes "U19" unhyphenated, so 'u-19'/'under-19' would match nothing. 'test
    // series', 'sri lanka' and 'india' were all rejected — they collide with kept
    // internationals (the last one would hide the Indian Premier League).
    'u19',
];

export const isLeagueBlocked = (input) => {
    if (!input) return false;
    const name = (
        typeof input === 'string' ? input :
        (input?.competition?.name || input?.competition || input?.league || input?.series || input?.competitionName || '')
    ).toLowerCase();
    if (!name) return false;
    return BLOCKED_LEAGUES.some(bl => name.includes(bl));
};
